import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { useCurrentCommunityMember } from "@circle-react/contexts/punditUserContext";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { memberProfileModalPaths } from "@/react/helpers/urlHelpers/memberProfileModalPaths";

export const Banner = () => {
  const currentCommunityMember = useCurrentCommunityMember();
  const navigate = useNavigate();

  const isMessagingEnabled =
    currentCommunityMember?.messaging_enabled_by_member &&
    currentCommunityMember?.messaging_enabled_by_admin;

  if (isMessagingEnabled) {
    return null;
  }

  const openEditProfile = () => {
    void navigate({ to: memberProfileModalPaths.privacy });
  };

  const isAdmin = currentCommunityMember?.is_admin;
  return (
    <div className="flex h-[81px] w-full items-center justify-between rounded-t-md bg-tertiary px-4 py-3">
      <div className="mr-3 flex items-center gap-3">
        <div className="w-5">
          <Icon type="20-info-circle" className="text-dark" size={20} />
        </div>
        <Typography.BodyXs>
          {isAdmin
            ? t("messaging.banner.admin_messaging_disabled")
            : t("messaging.banner.member_messaging_disabled")}
        </Typography.BodyXs>
      </div>
      <Button
        variant="plain"
        onClick={openEditProfile}
        className="!font-medium !text-dark focus-within:!outline-none"
      >
        {t("messaging.banner.manage")}
      </Button>
    </div>
  );
};
